import { Injectable, OnChanges, OnInit } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import {
  dblclickTooltipDef,
  defaultColumn,
  grid_widths_map,
  mainModuleName,
  rolesModuleName,
  subModuleName,
} from '@piqet-angular/shared';
import { right } from '@popperjs/core';
import { AdministratorFacade, getRolesAndPermission } from '@piqet-angular/data';
import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class OtherMaterialDataGridService {
  otherMaterialDataPayload: any;
  event: any;

  openMaterialModalData = new Subject<[any, any, any]>();
  materialObservable$ = this.openMaterialModalData.asObservable();

  constructor(private AdministratorFacade: AdministratorFacade) {}

  getOtherMaterialDataColumn(pathName?: any): ColDef[] {
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'MaterialCategoryName',
      headerName: 'Material category',
      field: 'materialCategoryName',
      cellClass: 'my-permission-cursor-pointer',
      // sort: 'asc',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      filter: 'agTextColumnFilter',
      editable: false,
      cellRenderer: (params: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        cellElement.innerHTML = `${cellValue}`;
        cellElement.style.cursor = 'pointer';
        cellElement.style.textDecoration = 'underline';
        cellElement.title = dblclickTooltipDef;
        cellElement.addEventListener('dblclick', () => {
          const headerName =
            pathName === 'material-types'
              ? 'Review material type detail'
              : pathName === 'Recyclability'
              ? 'Review recyclability detail'
              : pathName === 'Combustibility'
              ? 'Review combustibility detail'
              : pathName === 'Compostability'
              ? 'Review compostability detail'
              : '';
          if (
            params.columnApi.columnModel.columnDefs[
              params.columnApi.columnModel.columnDefs.length - 1
            ].cellRendererParams?.showEdit
          )
            this.openMaterialModalData.next([params.data?.materialId, headerName, pathName]);
        });
        return cellElement;
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'MaterialCode',
      headerName: 'Material code',
      field: 'materialCode',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      filter: 'agTextColumnFilter',
      resizable: false,
      editable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'MaterialName',
      headerName: 'Material',
      field: 'materialName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      filter: 'agTextColumnFilter',
      resizable: false,
      editable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'OrganizationName',
      headerName: 'Organization',
      field: 'organizationName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      filter: 'agTextColumnFilter',
      resizable: false,
      editable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Actions',
      headerName: 'Actions',
      field: 'actions',
      sortable: false,
      cellRendererParams: {
        showCopy: false,
        showDelete: false,
        showEdit: this.isAccess(pathName) ? this.isAccess(pathName).isEdit : true,
        editData: (data: any, pathName: any) => {
          const headerName =
            pathName === 'material-types'
              ? 'Review material type detail'
              : pathName === 'Recyclability'
              ? 'Review recyclability detail'
              : pathName === 'Combustibility'
              ? 'Review combustibility detail'
              : pathName === 'Compostability'
              ? 'Review compostability detail'
              : '';
          this.openMaterialModalData.next([data.materialId, headerName, pathName]);
        },
      },
      maxWidth: grid_widths_map.sm_column_xs,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'actionRenderer',
      lockVisible: true,
      lockPosition: right,
      resizable: false,
    });
    return colDef;
  }

  isAccess = (pathName: any) => {
    switch (pathName) {
      case 'material-types':
        return getRolesAndPermission(
          rolesModuleName.DataManageMaterialTypes,
          subModuleName.otherDataModule
        );
        break;
      case 'Recyclability':
        return getRolesAndPermission(
          rolesModuleName.DataManageOtherDataRecyclability,
          subModuleName.otherDataModule
        );
        break;
      case 'Combustibility':
        return getRolesAndPermission(
          rolesModuleName.DataManageOtherDataCombustibility,
          subModuleName.otherDataModule
        );
        break;
      case 'Compostability':
        return getRolesAndPermission(
          rolesModuleName.DataManageOtherDataCompostability,
          subModuleName.otherDataModule
        );
        break;
    }
    // return getRolesAndPermission(rolesModuleName.DataManageMaterialTypes,subModuleName.otherDataModule);
  };

  getPayload(searchData: any, sortColumnState?: any, event?: any) {
    if (event) {
      this.event = event;
    }
    const currentPage = this.event?.goToPage
      ? this.event.goToPage
      : this.event?.next
      ? this.event.currentPage + 1
      : this.event?.prev
      ? this.event?.currentPage - 1
      : this.event?.gridApi?.paginationGetCurrentPage() + 1;
    const pageSize = this.event?.gridApi.paginationGetPageSize();
    const startCount = pageSize * (currentPage - 1);

    const columns = this.getOtherMaterialDataColumn()
      .map((item: any) => {
        return {
          searchable: true,
          name: item.colId,
          orderable: true,
          data: item.colId,
        };
      })
      .filter(value => value?.name != 'Actions');

    return (this.otherMaterialDataPayload = {
      search: {
        columnNameList: [],
        value: searchData || '',
      },
      columns: columns,
      order: [
        {
          columnName: sortColumnState?.columnName || 'MaterialCategoryName',
          dir:
            sortColumnState?.dir[0].toUpperCase() + sortColumnState?.dir.substr(1).toLowerCase() ||
            'Asc',
        },
      ],
      start: startCount || 0,
      length: pageSize == Number(this.event?.totalRecord) ? Number('-1') : pageSize || 10,
      draw: currentPage || 1,
    });
  }
}
